<template>
    <el-dialog title="设备回拨" :visible.sync="dialogValue" :show-close="false" :close-on-click-modal="false">
        <el-form :model="form">
            <el-form-item label="填写SN号" class="ml">
                <el-radio v-model="form.radio" :label="0" @change="snTypeChange">多个SN</el-radio>
                <el-radio v-model="form.radio" :label="1" @chajnge="snTypeChange">SN号段</el-radio>
                <el-input type="textarea" :rows="2" placeholder="可输入多个sn，以英文逗号或换行分制" v-model="form.textarea"
                    v-if="form.radio === 0">
                </el-input>
                <div v-else="form.radio === 1 ">
                    <span>开始号段</span>
                    <el-input v-model="form.startNumber" controls-position="right" @change="updateRange" size="small"
                        style="width: 120px;">
                    </el-input>
                    <span>至</span>
                    <el-input v-model="form.endNumber" controls-position="right" @change="updateRange" size="small"
                        style="width: 120px;">
                    </el-input>
                    <span>结束号段</span>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="sureFunc">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import equipmentApi from '@/api/equipment/messagecontrol.js'
export default {
    props: ['callBackMessage', 'snNums'],
    data() {
        return {
            dialogValue: false,
            form: {
                radio: 0, // 填写SN号方式
                textarea: '', // 文本域SN号
                startNumber: '', // 开始号段
                endNumber: '', // 结束号段
                value: [0, 0]
            }
        }
    },
    methods: {
        // 当切换SN方式时
        snTypeChange() {
            this.form.textarea = '';
            this.form.startNumber = '';
            this.form.endNumber = '';
        },
        // 
        updateRange() {
            // this.form.value[0] = this.form.startNumber;
            // this.form.value[1] = this.form.endNumber;
            // console.log('form.value', this.form.value)
        },
        // 关闭组件
        handleCancel() {
            this.dialogValue = false // 关闭弹窗
            this.$emit('closeFunction', this.dialogValue) // 传递数据给父组件
        },
        sureFunc() {
            // console.log(this.form);
            if (this.form.radio === 1 && !this.form.startNumber.trim() && !this.form.startNumber.trim()) {
                this.$message({
                    message: '请填写完整信息',
                    type: 'warning'
                });
                return;
            } else if (this.form.radio === 0 && !this.form.textarea.trim()) {
                this.$message({
                    message: '请填写完整信息',
                    type: 'warning'
                });
                return;
            }

            if (this.form.radio == 0) {
                const params = {
                    transferType: this.form.radio,
                    snCodes: this.form.textarea
                }
                this.backFunc(params)
            } else if (this.form.radio == 1) {
                const params = {
                    transferType: this.form.radio,
                    startSnCode: this.form.startNumber,
                    endSnCode: this.form.endNumber
                }
                this.backFunc(params);
            }
            this.dialogValue = false // 关闭弹窗
            this.$emit('closeFunction', this.dialogValue) // 传递数据给父组件
            this.$emit('add-success');
        },
        backFunc(params) {
            equipmentApi.getEquipmentCallBack({ ...params }).then(res => {
                this.$message({
                    message: '回拨成功',
                    type: 'success'
                });
            }).catch(err => {
            })
        }
    },
    watch: {
        callBackMessage(newVal) {
            this.dialogValue = newVal // 监视 props 的变化，将值赋给子组件的 data 属性
        },
        snNums(newVal) {
            // console.log(newVal);
            this.form.textarea = newVal
        },
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/equipment/messagecontrol/components/CallBack.vue